var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSrcPortalIconsBlack07(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.67 24.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5664",
    "data-name": "Group 5664"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7850",
    "data-name": "Path 7850",
    d: "M14.85,10.27c-.08-.12-.18-.23-.3-.31v-4.04c1.22.08,2.44-.14,3.55-.65,1.11-.51,2.37-.61,3.55-.27V.07c-1.44-.23-2.91.07-4.15.82-.95.69-2.94.33-2.94.33V.36h-.95v9.49c-.21.08-.38.23-.5.42l-3.87,6.45-1.26-2.1c-.29-.48-.92-.64-1.4-.35-.14.09-.27.21-.35.35L0,24.99h23.67l-8.82-14.72Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSrcPortalIconsBlack07);
export default __webpack_public_path__ + "static/media/SRC-Portal-Icons-Black-07.1fe5c09973c05811fc9049ca9dd00cb4.svg";
export { ForwardRef as ReactComponent };